import { createSlice } from '@reduxjs/toolkit';

const loadCartItems = () => {
  try {
    const raw = localStorage.getItem('cartItems');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((item) => ({
      ...item,
      moqType: item.moqType || 'pcs',
      unitsPerSet: item.unitsPerSet || 1,
    }));
  } catch (err) {
    console.error('Error loading cart items:', err);
    return [];
  }
};

const loadAppliedCoupon = () => {
  try {
    const raw = localStorage.getItem('appliedCoupon');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
};

const initialState = {
  cartItems: loadCartItems(),
  sectionNotes: localStorage.getItem('sectionNotes') ? JSON.parse(localStorage.getItem('sectionNotes')) : {},
  appliedCoupon: loadAppliedCoupon(),
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = {
        ...action.payload,
        moqType: action.payload.moqType || 'pcs',
        unitsPerSet: action.payload.unitsPerSet || 1,
      };
      const existItem = state.cartItems.find((x) => x.productId === item.productId);
      if (existItem) {
        state.cartItems = state.cartItems.map((x) =>
          x.productId === existItem.productId ? item : x
        );
      } else {
        state.cartItems.push(item);
      }
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter((x) => x.productId !== action.payload);
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    updateSectionNote: (state, action) => {
      const { section, note } = action.payload;
      state.sectionNotes[section] = note;
      localStorage.setItem('sectionNotes', JSON.stringify(state.sectionNotes));
    },
    clearCart: (state) => {
      state.cartItems = [];
      state.sectionNotes = {};
      state.appliedCoupon = null;
      localStorage.removeItem('cartItems');
      localStorage.removeItem('sectionNotes');
      localStorage.removeItem('appliedCoupon');
    },
    setCartItems: (state, action) => {
      state.cartItems = action.payload || [];
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    updateCartItemQty: (state, action) => {
      const { productId, qty } = action.payload;
      if (qty <= 0) {
        state.cartItems = state.cartItems.filter((x) => x.productId !== productId);
      } else {
        const item = state.cartItems.find((x) => x.productId === productId);
        if (item) {
          item.qty = qty;
        }
      }
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    setAppliedCoupon: (state, action) => {
      state.appliedCoupon = action.payload;
      if (action.payload) {
        localStorage.setItem('appliedCoupon', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('appliedCoupon');
      }
    },
    removeAppliedCoupon: (state) => {
      state.appliedCoupon = null;
      localStorage.removeItem('appliedCoupon');
    }
  },
});

export const { 
  addToCart, 
  removeFromCart, 
  updateSectionNote, 
  clearCart, 
  setCartItems, 
  updateCartItemQty,
  setAppliedCoupon,
  removeAppliedCoupon
} = cartSlice.actions;
export default cartSlice.reducer;


